angular.module('actionslider', ['pascalprecht.translate'])
  .run(['$rootScope', 'Actionslider', function ($rootScope, Actionslider) {
    $rootScope.$on('userPool.login.success', function () {
      Actionslider.display($rootScope.user);
    });
  }]);
